export default __webpack_public_path__ + "static/media/MONEY.9af70f76.png";